import React from "react";
import { motion } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import SEOHead from "../components/common/SEOHead";

import EXECountdown from "../components/EXE/EXECountdown";
import EXETimeline from "../components/EXE/EXETimeline";
import EXECategories from "../components/EXE/EXECategories";
import EXESponsors from "../components/EXE/EXESponsors";
import EXEStats from "../components/EXE/EXEStats";

const Exe2025 = () => {
  return (
    <HelmetProvider>
      <div className="exe-bg-pattern min-h-screen pt-20">
        <SEOHead
          title="EXE 2025 - Sri Lanka's Premier Game Development Competition"
          description="Get ready for EXE 2025! Sri Lanka's flagship game development competition returns with exciting categories, amazing prizes, and industry collaboration opportunities."
          keywords="EXE 2025, game development, competition, Sri Lanka, Unity, Unreal Engine, indie games"
        />

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden z-0">
          {[...Array(12)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-2 h-2 bg-exe-primary opacity-30 rounded-full"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                scale: 0.5 + Math.random() * 1.5,
              }}
              animate={{
                y: [0, -30, 0],
                opacity: [0.1, 0.3, 0.1],
                scale: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 2 + Math.random() * 6,
                repeat: Infinity,
                delay: Math.random() * 3,
              }}
            />
          ))}
        </div>

        <div className="relative z-10">
          {/* Hero Section for EXE 2025 */}
          <section id="exe2025-hero" className="exe-section">
            <div className="exe-container">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-center"
              >
                <motion.h1
                  className="exe-title text-exe-text-accent mb-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                >
                  EXE 2025
                </motion.h1>
                <motion.p
                  className="exe-text text-xl mb-8 max-w-3xl mx-auto"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                >
                  Sri Lanka's flagship game development competition returns! Get
                  ready for an even bigger and better experience in 2025.
                </motion.p>

                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                  className="exe-glass-card p-8 max-w-2xl mx-auto"
                >
                  <h3 className="text-2xl font-bold text-exe-text-accent mb-4">
                    Stay Tuned for EXE 2026!
                  </h3>
                  <p className="exe-text text-lg">
                    Registration details, dates, and exciting new features
                    coming soon. Follow us on social media to be the first to
                    know when registrations open.
                  </p>
                </motion.div>
              </motion.div>
            </div>
          </section>

          {/* Collaborators/Sponsors */}
          <section id="sponsors">
            <EXESponsors />
          </section>
          {/* Competition Overview Stats */}
          <section id="stats">
            <EXEStats />
          </section>

          {/* Event Timeline */}
          <section id="timeline">
            <EXETimeline />
          </section>

          {/* Event Countdown */}
          <section id="countdown">
            <EXECountdown />
          </section>

          {/* Categories */}
          <section id="categories">
            <EXECategories />
          </section>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default Exe2025;
